import React from 'react';

import CommonHeaderContainer from '../../containers/commonHeaderContainer';
import CompleteDashboardHeader from '../../containers/dashboardHeaderContainer';
import AccountSettingsHeader from './AccountSettingsHeader/AccountSettingsHeader';
import endpointDashboardHeader from './DashboardHeader/dashboardHeader.json';
import EmptyHeader from './EmptyHeader';
import FlashcardCompleteHeader from './FlashcardCompleteHeader/FlashcardCompleteHeader';
import ManageSubscriptionHeader from './ManageSubscriptionHeader/ManageSubscriptionHeaderView';
import NotificationsViewHeader from './NotificationsViewHeader/NotificationsViewHeader';
import ReferAFriendHeader from './ReferAFriendHeader/ReferAFriendHeader';
import ResourcesHeader from './ResourcesHeader/ResourcesHeader';
import StudyHeader from './StudyHeader/studyHeader';
import StudyHeaderChosen from './StudyHeader/StudyHeaderChosen';
import SubmitAQuestionHeader from './SubmitAQuestionHeader/SubmitAQuestionHeader';

class MainHeader extends React.Component {
  evaluateLocation = () => {
    const location = this.props.location.pathname;
    const { userSubscription } = this.props;

    let warfare = false;
    if (userSubscription) {
      warfare = userSubscription.warfarePlan;
    }

    // Headers
    switch (true) {
      case location.includes('study-all'):
        return (
          <StudyHeaderChosen
            history={this.props.history}
            mainTitle="Study All"
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('quals'):
        return (
          <StudyHeaderChosen
            history={this.props.history}
            mainTitle="Quals and Certs"
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('daily-quiz'):
        return (
          <StudyHeaderChosen
            history={this.props.history}
            mainTitle="Daily Quiz"
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('personalized-study'):
        return (
          <StudyHeaderChosen
            history={this.props.history}
            mainTitle="Personalized Study"
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('exams'):
        return (
          <StudyHeaderChosen
            history={this.props.history}
            mainTitle="Practice Exam"
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('audio-study'):
        return (
          <StudyHeaderChosen
            history={this.props.history}
            mainTitle="Audio Study"
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('study') &&
        !location.includes('studyFavoriteQuestion') &&
        !location.includes('studySubmittedQuestions') &&
        !location.includes('studyMySubmittedQuestion') &&
        !location.includes('studyMyFavoriteQuestion'):
        return (
          <StudyHeader
            setBackTo={this.props.setBackTo}
            history={this.props.history}
            user={this.props.user}
            quizAvailable={this.props.quizAvailable}
            nextQuizIn={this.props.nextQuizIn}
            dailyQuizRunning={this.props.dailyQuizRunning}
            checkDailyQuizStatusWaiting={this.props.checkDailyQuizStatusWaiting}
            checkDailyQuizStatus={this.props.checkDailyQuizStatus}
            warfarePlan={warfare}
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />
        );

      case location.includes('flashcard'):
        return (
          <FlashcardCompleteHeader
            history={this.props.history}
            questionNotificationState={this.props.questionNotificationState}
            receiveQuestionsNotification={
              this.props.receiveQuestionsNotification
            }
          />
        );

      case location.includes('account-settings'):
        return <AccountSettingsHeader history={this.props.history} />;

      case location.includes('manage-subscription'):
        return <ManageSubscriptionHeader history={this.props.history} />;

      case location.includes('dashboard') ||
        location.includes('education-center'):
        return (
          <CompleteDashboardHeader
            user={this.props.user}
            data={endpointDashboardHeader}
          />
        );
      case location.includes('resources'):
        return <ResourcesHeader history={this.props.history} />;

      case location.includes('notifications'):
        return <NotificationsViewHeader />;

      case location.includes('submit-question'):
        return <SubmitAQuestionHeader />;

      case location.includes('refer-a-friend'):
        return <ReferAFriendHeader />;

      default:
        return <EmptyHeader history={this.props.history} />;
    }
  };

  render() {
    // If you want to hide the account expired popup modify the hidePopUp propr to true
    if (this.props.showMenu) {
      return (
        <div className="main-header">
          <CommonHeaderContainer
            userSubscription={this.props.userSubscription}
            user={this.props.user}
            history={this.props.history}
            location={this.props.location}
            hidePopUp={false}
            setShowMobileMenu={this.props.setShowMobileMenu}
            activateSubscription={this.props.activateSubscription}
            subscriptionActivationSucces={
              this.props.subscriptionActivationSucces
            }
            subscriptionActivationWaiting={
              this.props.subscriptionActivationWaiting
            }
            subscriptionActivationMessage={
              this.props.subscriptionActivationMessage
            }
          />
          {this.evaluateLocation()}
        </div>
      );
    }
    return null;
  }

  static propTypes = {
    // history: PropTypes.object.isRequired,
  };
}

export default MainHeader;
